export const FEEDBACK_REFERENCE_RE = /\{\{([^{}:\n]+):\s*([1-9]\d*)\}\}/g;

const NAMED_HTML_ENTITIES = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '\u0022',
  apos: '\u0027',
  nbsp: '\u00a0',
};

export const decodeHtmlEntities = value => {
  if (!value || value.indexOf('&') === -1) {
    return value || '';
  }

  return value.replace(/&(#x[\da-fA-F]+|#\d+|[a-zA-Z]+);/g, (entity, body) => {
    if (body.charAt(0) !== '#') {
      return Object.prototype.hasOwnProperty.call(NAMED_HTML_ENTITIES, body)
        ? NAMED_HTML_ENTITIES[body]
        : entity;
    }

    const codePoint = body.charAt(1).toLowerCase() === 'x'
      ? parseInt(body.slice(2), 16)
      : parseInt(body.slice(1), 10);

    if (
      !Number.isFinite(codePoint)
      || codePoint < 0
      || codePoint > 0x10FFFF
      || (codePoint >= 0xD800 && codePoint <= 0xDFFF)
    ) {
      return entity;
    }

    if (codePoint <= 0xFFFF) {
      return String.fromCharCode(codePoint);
    }

    const adjusted = codePoint - 0x10000;

    return String.fromCharCode(0xD800 + (adjusted >> 10), 0xDC00 + (adjusted & 0x3FF));
  });
};

export const tokenizeFeedbackReferences = content => {
  const segments = [];
  const expression = new RegExp(FEEDBACK_REFERENCE_RE.source, 'g');
  let cursor = 0;
  let match = expression.exec(content);

  while (match) {
    const start = match.index;

    if (start > cursor) {
      segments.push({ type: 'text', value: content.slice(cursor, start) });
    }

    segments.push({
      type: 'feedback-reference',
      value: {
        raw: match[0],
        label: match[1].trim(),
        feedbackId: Number(match[2]),
      },
    });

    cursor = start + match[0].length;
    match = expression.exec(content);
  }

  if (cursor < content.length) {
    segments.push({ type: 'text', value: content.slice(cursor) });
  }

  return segments;
};

// Hide a trailing {{... that has not closed yet so the typewriter does not flash the raw token.
export const stripIncompleteFeedbackToken = content => {
  if (!content) {
    return '';
  }

  const openIndex = content.lastIndexOf('{{');

  if (openIndex === -1) {
    return content;
  }

  if (content.indexOf('}}', openIndex + 2) === -1) {
    return content.slice(0, openIndex);
  }

  return content;
};

export const formatFeedbackReferenceLabel = (label, feedbackId) => `#${feedbackId} ${label}`;
